export {composedSorter,levelSorter,reverseSorter}

function composedSorter(sort1,sort2){
  let sorters = arguments;
  return function(a,b){
    for(var i=0;i<sorters.length;i++){
      let partialresult = sorters[i](a,b);
      if(partialresult!==0){
        return partialresult;
      }
    }
    return 0;
  }
}
function levelSorter(leveler){
  return function(a,b){
    try{
      return (leveler(a)-leveler(b))||0; 
    }catch(e){
      console.log(e);
      return 0;
    }
  };
}
function reverseSorter(sorter){
  return function(a,b){
    return sorter(b,a);
  };
}